namespace advisorop.services {
    "use strict";
    export class ServicerService {

        static $inject = ["$http", "backOfficeLinkApi"];
        constructor(private $http: ng.IHttpService, private backOfficeLinkApi: services.BackOfficeLinkApi) {
        }

        /**
         * Pointers to opened browser windows with PP screens
         */
        private ppWnds = {};

        prepareAccountForPost(account: domains.IAccount): domains.IAccount {
            for (let i: number = 0; i < account.investors.length; i++) {
                account.investors[i].companyGroup = null;
                account.investors[i].systemLogin = null;
            }
            return account;
        }

        replaceSlashes(str: string): string {
            var ret: string = str;
            if (ret != null)
                ret = str.replace(/\/|\\/g, "-");
            return ret;
        }

       // #region System
        getSystemStatus(): ng.IHttpPromise<domains.ISystemStatus[]> {
            return this.$http.get("api/servicer/getsystemstatus");
        };
        // #endregion System

        // methods for CompanyGroup Firms

        getCompanyGroups(): ng.IHttpPromise<Array<domains.ICompanyGroup>> {
            return this.$http.get("api/servicer/getcompanygroups");
        };

        // #region System-admin maintenance (login 00000001 only, gated server-side)
        getInvestorsForAdminSync(): ng.IHttpPromise<Array<domains.IAdminInvestorSyncRow>> {
            return this.$http.get("api/adminmaintenance/getallinvestors");
        };

        syncInvestorsWithSalesforce(investorIds: number[]): ng.IHttpPromise<domains.ISyncInvestorsResult> {
            return this.$http.post("api/adminmaintenance/syncinvestors", { investorIds: investorIds });
        };

        getHouseholdsForAdminMaintenance(): ng.IHttpPromise<Array<domains.IAdminHouseholdRow>> {
            return this.$http.get("api/adminmaintenance/gethouseholds");
        };

        retireHousehold(householdId: number): ng.IHttpPromise<domains.IRetireHouseholdResult> {
            return this.$http.post("api/adminmaintenance/retirehousehold", { householdId: householdId });
        };
        // #endregion System-admin maintenance

        getCompanyGroup(companyGroupId: number): ng.IHttpPromise<domains.ICompanyGroup> {
            return this.$http.get("api/servicer/getcompanygroup/" + companyGroupId);
        };

        searchCompanyGroupByName(searchTerm: string): ng.IHttpPromise<{}> {
            return this.$http.get("/api/servicer/searchcompanygroupbyname/" + searchTerm);
        };

        createCompanyGroup(model: domains.ICompanyGroup): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/createcompanygroup", model);
        };


        updateCompanyGroup(companyGroupModel: domains.ICompanyGroup): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/updatecompanygroup", companyGroupModel);
        };

        // //////////////////////////////////////
        // methods for account

        openAccount(account: domains.IAccount, companyGroupId: number): ng.IHttpPromise<domains.IAccount> {
            account = this.prepareAccountForPost(account);

            return this.$http.post("/api/servicer/openaccount/" + companyGroupId, account);
        };

        updateAccount(account: domains.IAccount, companyGroupId: number): ng.IHttpPromise<domains.IAccount> {
            account = this.prepareAccountForPost(account);
            return this.$http.post("/api/servicer/updateaccount/" + companyGroupId, account);
        };
        
        // #region Individual System Login
        searchInvestors(searchTerm: string, advFrmId: number): ng.IHttpPromise<Array<domains.IInvestor>> {
            return this.$http.get("/api/servicer/searchInvestors/" + searchTerm + "/" + advFrmId);
        }
        getAccount(accountId: number): ng.IHttpPromise<domains.IAccount> {
            return this.$http.get("/api/servicer/getaccount/" + accountId);
        };

        getPPAccount(ppAccountId: number): ng.IHttpPromise<domains.IPPAccountProfile> {
            return this.$http.get("/api/servicer/getppaccount/" + ppAccountId);
        };

        getUnmappedAccounts(ppCompanyGroupId: string): ng.IHttpPromise<Array<domains.IAccount>> {
            return this.$http.get("/api/servicer/getunmappedaccountsservicer/" + ppCompanyGroupId);
        };

        enableInvestorSL(model: domains.IInvestor): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/enableinvestorsl", model);
        };

        reactivateInvestorSL(model: domains.IInvestor): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/reactivateinvestorsl", model);
        };

        disableInvestorSL(model: domains.IInvestor): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/disableinvestorsl", model);
        };

        lockInvestorSL(model: domains.IInvestor): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/lockinvestorsl", model);
        };

        unlockInvestorSL(model: domains.IInvestor): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/unlockinvestorsl", model);
        };
        // #endregion Individual System Login

        // #region Advisor
        getAllAdvisors(): ng.IHttpPromise<Array<domains.IAdvisor>> {
            return this.$http.get("api/servicer/getalladvisors");
        };

        updateAdvisor(model: domains.IAdvisor): ng.IHttpPromise<{}> {
            return this.$http.post(`/api/servicer/updateadvisor`, model);
        }

        getAdvisors(companyGroupId: number): ng.IHttpPromise<Array<domains.IAdvisor>> {
            return this.$http.get("api/servicer/getadvisors/" + companyGroupId);
        };


        getAdvisor(advisorId: number): ng.IHttpPromise<domains.IAdvisor> {
            return this.$http.get("api/servicer/getadvisor/" + advisorId);
        };

        createAdvisor(model: domains.IAdvisor): ng.IHttpPromise<{ data, warnings: any[] }> {
            return this.$http.post("/api/servicer/createadvisor", model);
        };

        enableAdvisorSL(model: domains.IAdvisor): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/enableadvisorsl", model);
        };

        reactivateAdvisorSL(model: domains.IAdvisor): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/reactivateadvisorsl", model);
        };

        disableAdvisorSL(model: domains.IAdvisor): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/disableadvisorsl", model);
        };

        setSsoModeAdvisorSL(model: domains.IAdvisor, mode: number): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/setssomodeadvisorsl/" + mode, model);
        }

        setTwoFactorAdvisorSL(model: domains.IAdvisor, enabled: boolean, days?: number): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/settwofactoradvisorsl/" + enabled + (days ? "?days=" + days : ""), model);
        };

        lockAdvisorSL(model: domains.IAdvisor): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/lockadvisorsl", model);
        };

        unlockAdvisorSL(model: domains.IAdvisor): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/unlockadvisorsl", model);
        }

        searchAdvisors(searchTerm: string, companyGroupId: number): ng.IHttpPromise<Array<domains.IAdvisor>> {
            return this.$http.get("/api/servicer/searchAdvisors/" + searchTerm + "/" + companyGroupId);
        }
        // #endregion Advisor

        searchInvestorsAll(searchTerm: string): ng.IHttpPromise<Array<domains.ISearchInvestorHouseholdResults>> {
            return this.$http.get(`/api/servicer/searchinvestorsall/${searchTerm}`);
        }

        // #region MonitorsAndReconciliation
        sleeveModelRec(): ng.IHttpPromise<Array<domains.ISleeveModelRec>> {
            return this.$http.get("/api/servicer/sleevemodelrec");
        }

        getNonZeroCashMonitorData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/nonzerocashmonitor/" + firmId);
        }

        getCashMonitorData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/cashmonitor/" + firmId);
        }

        getNegCashMonitorData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/negcashmonitor/" + firmId);
        }

        getCashDistributionsData(firmId: number, choice: number): ng.IHttpPromise<any[]> {
            if (choice == 0) {
                return this.$http.get("/api/servicer/cashwithdrawals/" + firmId);
            } else {
                return this.$http.get("/api/servicer/cashdeposits/" + firmId);
            }
        }

        getFundingCashMonitorData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/fundingcashmonitor/" + firmId);
        }

        getModelCashMonitorData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/modelcashmonitor/" + firmId);
        }

        getFundingPosnMonitorData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/fundingposnmonitor/" + firmId);
        }

        getTargetModelAllocRecData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/targetmodelallocationrec/" + firmId);
        }
        updateInvestorRMDStatus(rmdStatusViewModel: domains.InvestorRmdStatusViewModel): ng.IHttpPromise<domains.InvestorRmdStatusViewModel> {
            return this.$http.post(`/api/servicer/updateinvestorrmdstatus`, rmdStatusViewModel);
        }
        updateAccountRMDStatus(rmdStatusViewModel: domains.AccountRmdStatusViewModel): ng.IHttpPromise<domains.AccountRmdStatusViewModel> {
            return this.$http.post(`/api/servicer/updateaccountrmdstatus`, rmdStatusViewModel);
        }
        getOrionModelMonitorData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/orionmodelmonitor/" + firmId);
        }
        getOrionFeeMonitorData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/orionfeemonitor/" + firmId);
        }
        getOrionHighCashModelMonitorData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/orioncashmodelmonitor/" + firmId);
        }
        getOrionHighCashNonModelMonitorData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/orioncashnonmodelmonitor/" + firmId);
        }
        getOrionAccSyncMonitorData(firmId: number): ng.IHttpPromise < any[] > {
            return this.$http.get("/api/servicer/orionaccountsyncmonitor/" + firmId);
        }
        getAoAccountsNotInOrionData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/aoaccountsnotinorion/" + firmId);
        }
        getBillingStyleMonitorData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/orionbillingstylemonitor/" + firmId);
        }
        getTieredBillingAggregateMonitorData(firmId: number): ng.IHttpPromise<any[]> {
            return this.$http.get("/api/servicer/tieredbillingaggregatemonitor/" + firmId);
        }
        // #endregion MonitorsAndReconciliation


        // #region Manager
        getManagers(): ng.IHttpPromise<Array<domains.IManager>> {
            return this.$http.get("/api/servicer/getmanagers");
        }

        getManagerById(managerId: number): ng.IHttpPromise<domains.IManager> {
            return this.$http.get("/api/servicer/getmanagerbymanagerid/" + managerId);
        }

        createManager(manager: domains.IManager): ng.IHttpPromise<domains.IManager> {
            return this.$http.post("/api/servicer/createmanager", manager);
        }

        updateManager(manager: domains.IManager): ng.IHttpPromise<domains.IManager> {
            return this.$http.put("/api/servicer/updatemanager", manager);
        }

        deleteManager(managerId: number): ng.IHttpPromise<any> {
            return this.$http.delete(`/api/servicer/deletemanager/${managerId}`);
        }

        setManagerStatus(manager: domains.IManager, managerStatus: domains.Status): ng.IHttpPromise<any> {
            return this.$http.put("/api/servicer/setmanagerstatus/" + managerStatus, manager);
        }

        searchManager(searchTerm: string): ng.IHttpPromise<domains.IManager[]> {
            return this.$http.get("api/servicer/searchmanager/" + searchTerm);
        };

        // #endregion Manager

        // #region Manager Product Types
        getManagerProductTypes(managerId: number): ng.IHttpPromise<Array<domains.IManagerProductType>> {
            return this.$http.get("/api/servicer/getmanagerproducttypes/" + managerId);
        }

        setManagerProductTypeStatus(managerProductType: domains.IManagerProductType, managerProductTypeStatus: domains.Status): ng.IHttpPromise<any> {
            return this.$http.put("/api/servicer/setmanagerproducttypestatus/" + managerProductTypeStatus, managerProductType);
        }

        setManagerProductStatus(managerProduct: domains.IManagerProduct, managerProductStatus: domains.Status): ng.IHttpPromise<any> {
            return this.$http.put("/api/servicer/setmanagerproductstatus/" + managerProductStatus, managerProduct);
        }

        getManagerAllProductTypes(): ng.IHttpPromise<Array<domains.IManagerProductType>> {
            return this.$http.get("/api/servicer/getmanagerproducttypes");
        }

        createManagerProductType(productType: domains.IManagerProductType):
            ng.IHttpPromise<domains.IManagerProductType> {
            return this.$http.post("/api/servicer/assignmanagerproducttype", productType);
        }

        updateManagerProductType(managerProductType: domains.IManagerProductType):
            ng.IHttpPromise<domains.IManagerProductType> {
            return this.$http.put("/api/servicer/updatemanagerproducttype", managerProductType);
        }

        deleteManagerProductType(managerProductTypeId: number): ng.IHttpPromise<any> {
            return this.$http.delete("/api/servicer/deletemanagerproducttype/" + managerProductTypeId);
        }
        // #endregion Manager Product Types

        // #region Firm Managers
        getFirmManagers(advisoryFirmId: number): ng.IHttpPromise<domains.IAdvisoryFirmManager[]> {
            return this.$http.get("/api/servicer/getfirmmanagers/" + advisoryFirmId);
        }
        getFirmManager(advisoryFirmManagerId: number): ng.IHttpPromise<domains.IAdvisoryFirmManager> {
            return this.$http.get("/api/servicer/getfirmmanager/" + advisoryFirmManagerId);
        }
        getFirmManagerByManagerId(managerId: number, advisoryFirmId: number): ng.IHttpPromise<domains.IAdvisoryFirmManager> {
            return this.$http.get("/api/servicer/getfirmmanagerbymanagerid/" + managerId + "/" + advisoryFirmId);
        }
        assignFirmManager(advisoryFirmManager: domains.IAdvisoryFirmManager): ng.IHttpPromise<domains.IAdvisoryFirmManager> {
            return this.$http.post("/api/servicer/assignfirmmanager", advisoryFirmManager);
        }
        deleteFirmManager(advisoryFirmManagerId: number): ng.IHttpPromise<any> {
            return this.$http.delete(`/api/servicer/deletefirmmanager/${advisoryFirmManagerId}`);
        }
        // #endregion Firm Managers

        // #region FirmProductType methods  
        getAdvisoryFirmProductTypes(advisoryFirmId: number, managerId: number): ng.IHttpPromise<domains.IAdvisoryFirmProductType[]> {
            return this.$http.get(`/api/servicer/getadvisoryfirmproducttypes/${advisoryFirmId}/${managerId}`);
        };

        getAdvisoryFirmProductTypesByFirm(advisoryFirmId: number): ng.IHttpPromise<domains.IAdvisoryFirmProductType[]> {
            return this.$http.get(`/api/servicer/getadvisoryfirmproducttypesbyfirm/${advisoryFirmId}`);
        };

        getAdvisoryFirmProductType(advisoryFirmProductTypeId: number): ng.IHttpPromise<domains.IAdvisoryFirmProductType> {
            return this.$http.get(`/api/servicer/getadvisoryfirmproducttype/${advisoryFirmProductTypeId}`);
        };

        assignFirmProductType(advisoryFirmProductType: domains.IAdvisoryFirmProductType):
            ng.IHttpPromise<domains.IAdvisoryFirmProductType> {
            return this.$http.post("/api/servicer/assignadvisoryfirmproducttype", advisoryFirmProductType);
        };

        updateAdvisoryFirmProductType(advisoryFirmProductType: domains.IAdvisoryFirmProductType):
            ng.IHttpPromise<domains.IAdvisoryFirmProductType> {
            return this.$http.put("/api/servicer/updateadvisoryfirmproducttype", advisoryFirmProductType);
        };

        deleteAdvisoryFirmProductType(advisoryFirmProductTypeId: number): ng.IHttpPromise<any> {
            return this.$http.delete(`/api/servicer/deleteadvisoryfirmproducttype/${advisoryFirmProductTypeId}`);
        };
        // #endregion FirmProductType methods

        // #region Firm Product
        getFirmProducts(advisoryFirmId: number): ng.IHttpPromise<domains.IAdvisoryFirmProduct[]> {
            return this.$http.get("/api/servicer/getfirmproducts/" + advisoryFirmId);
        }
        getFirmProduct(firmProductId: number): ng.IHttpPromise<domains.IAdvisoryFirmProduct> {
            return this.$http.get("/api/servicer/getfirmproduct/" + firmProductId);
        }
        getAssignedAdvisoryFirmTamps(firmProductId: number, advisoryFirmId: number): ng.IHttpPromise<Array<domains.IAdvisoryFirmTamp>> {
            return this.$http.get("/api/servicer/getassignedadvisoryfirmtamps/" + firmProductId + "/" + advisoryFirmId);
        };
        getTampsProduct(firmProductId: number, advisoryFirmId: number): ng.IHttpPromise<Array<domains.ITampProduct>> {
            return this.$http.get("/api/servicer/getassignedtampsproduct/" + firmProductId + "/" + advisoryFirmId);
        };
        createFirmProduct(firmProduct: domains.IAdvisoryFirmProduct):
            ng.IHttpPromise<domains.IAdvisoryFirmProduct> {
            return this.$http.post("/api/servicer/createfirmproduct", firmProduct);
        }
        updateFirmProduct(firmProduct: domains.IAdvisoryFirmProduct):
            ng.IHttpPromise<domains.IAdvisoryFirmProduct> {
            return this.$http.post("/api/servicer/updatefirmproduct", firmProduct);
        }
        deleteFirmProduct(firmProductId: number): ng.IHttpPromise<any> {
            return this.$http.delete("/api/servicer/deletefirmproduct/" + firmProductId);
        }
        // #endregion Firm Product

        // #region Manager Product
        getManagerProducts(): ng.IHttpPromise<domains.IManagerProduct[]> {
            return this.$http.get("/api/servicer/getmanagerproducts");
        }
        getManagerProductsByProductType(productTypeId: number, advisoryFirmId: number):
            ng.IHttpPromise<domains.IManagerProduct[]> {
            return this.$http.get(`/api/servicer/getmanagerproductsbyproducttype/${advisoryFirmId}/${productTypeId}`);
        }
        getManagerProductsByManagerProductType(managerProductTypeId: number, advisoryFirmId: number):
            ng.IHttpPromise<domains.IManagerProduct[]> {
            return this.$http.get(`/api/servicer/getmanagerproductsbymanagerproducttype/${advisoryFirmId}/${managerProductTypeId}`);
        }
        getManagerProductsByManager(managerId: number): ng.IHttpPromise<domains.IManagerProduct[]> {
            return this.$http.get(`/api/servicer/getmanagerproducts/${managerId}`);
        }
        getManagerProduct(managerProductId: number): ng.IHttpPromise<domains.IManagerProduct> {
            return this.$http.get("/api/servicer/getmanagerproduct/" + managerProductId);
        }
        createManagerProduct(managerProduct: domains.IManagerProduct):
            ng.IHttpPromise<domains.IManagerProduct> {
            return this.$http.post("/api/servicer/createmanagerproduct", managerProduct);
        }
        updateManagerProduct(managerProduct: domains.IManagerProduct):
            ng.IHttpPromise<domains.IManagerProduct> {
            return this.$http.put("/api/servicer/updatemanagerproduct", managerProduct);
        }
        deleteManagerProduct(managerProductId: number): ng.IHttpPromise<any> {
            return this.$http.delete("/api/servicer/deletemanagerproduct/" + managerProductId);
        }
        setAdvisoryFirmProductStatus(advisoryFirmProduct: domains.IAdvisoryFirmProduct, productStatus: domains.Status): ng.IHttpPromise<any> {
            return this.$http.put("/api/servicer/disableadvisoryfirmproduct/" + productStatus, advisoryFirmProduct);
        }
        // #endregion Manager Product

        // #region Tamp
        deleteTamp(tampId: number): ng.IHttpPromise<domains.ITamp> {
            return this.$http.delete(`/api/servicer/deletetamp/${tampId}`);
        }

        updateTamp(tamp: domains.ITamp): ng.IHttpPromise<domains.ITamp> {
            return this.$http.post("/api/servicer/updatetamp", tamp);
        }

        getTamps(): ng.IHttpPromise<Array<domains.ITamp>> {
            return this.$http.get("/api/servicer/gettamps");
        }

        getTampsById(tampId: number): ng.IHttpPromise<domains.ITamp> {
            return this.$http.get(`/api/servicer/gettamp/${tampId}`);
        }

        createTamp(tamp: domains.ITamp): ng.IHttpPromise<domains.ITamp> {
            return this.$http.post("/api/servicer/createtamp", tamp);
        }
        // #endregion Tamp

        // #region Firm Tamps
        getFirmTamps(advisoryFirmId: number): ng.IHttpPromise<domains.IAdvisoryFirmTamp[]> {
            return this.$http.get("/api/servicer/getfirmtamps/" + advisoryFirmId);
        }
        getFirmTamp(advisoryFirmTampId: number): ng.IHttpPromise<domains.IAdvisoryFirmTamp> {
            return this.$http.get("/api/servicer/getfirmtamp/" + advisoryFirmTampId);
        }
        assignFirmTamp(advisoryFirmTamp: domains.IAdvisoryFirmTamp): ng.IHttpPromise<domains.IAdvisoryFirmTamp> {
            return this.$http.post("/api/servicer/assignfirmtamp", advisoryFirmTamp);
        }
        unassignFirmTamp(advisoryFirmTampId: number): ng.IHttpPromise<any> {
            return this.$http.delete(`/api/servicer/deletefirmtamp/${advisoryFirmTampId}`);
        }
        // #endregion Firm Tamps

        // #region Tamp Product
        getTampProducts(tampId: number): ng.IHttpPromise<domains.ITampProduct[]> {
            return this.$http.get("/api/servicer/gettampproducts/" + tampId);
        }
        getTampProduct(tampProductId: number): ng.IHttpPromise<domains.ITampProduct> {
            return this.$http.get("/api/servicer/gettampproduct/" + tampProductId);
        }
        createTampProduct(tampProduct: domains.ITampProduct):
            ng.IHttpPromise<domains.ITampProduct> {
            return this.$http.post("/api/servicer/createtampproduct", tampProduct);
        }
        updateTampProduct(tampProduct: domains.ITampProduct):
            ng.IHttpPromise<domains.ITampProduct> {
            return this.$http.put("/api/servicer/updatetampproduct", tampProduct);
        }
        deleteTampProduct(tampProductId: number): ng.IHttpPromise<any> {
            return this.$http.delete("/api/servicer/deletetampproduct/" + tampProductId);
        }
        // #endregion Tamp Product

        // #region Firm Interfaces


        getFirmExtinterfaces(advisoryFirmId: number): ng.IHttpPromise<domains.IAFExtinterface[]> {
            return this.$http.get("/api/servicer/getafextinterfaces/" + advisoryFirmId);
        }
        addFirmExtinterface(afExtinterface: domains.IAFExtinterface): ng.IHttpPromise<domains.IAFExtinterface> {
            return this.$http.post("/api/servicer/addafextinterface", afExtinterface);
        }
        disableFirmExtinterface(afExtinterfaceId: number): ng.IHttpPromise<domains.IAFExtinterface> {
            return this.$http.put("/api/servicer/disableafextinterface/" + afExtinterfaceId, null);
        }
        enableFirmExtinterface(afExtinterfaceId: number): ng.IHttpPromise<domains.IAFExtinterface> {
            return this.$http.put("/api/servicer/enableafextinterface/" + afExtinterfaceId, null);
        }
        deleteFirmExtinterface(afExtinterfaceId: number): ng.IHttpPromise<any> {
            return this.$http.delete("/api/servicer/deleteafextinterface/" + afExtinterfaceId);
        }
        // #endregion Firm Interfaces

        // /////////////////////////////////////////
        // methods for Servicer system login
        createServicer(model: any): ng.IHttpPromise<{ data, warnings: string[] }> {
            return this.$http.post("/api/servicer/createservicer", model);
        };

        getServicers(): ng.IHttpPromise<Array<domains.identity.IUser>> {
            return this.$http.get("/api/servicer/getservicers");
        };

        getServicer(servicerId: string): ng.IHttpPromise<domains.IServicer> {
            return this.$http.get("/api/servicer/getservicer/" + servicerId);
        };

        updateServicer(model: domains.IServicer): ng.IHttpPromise<domains.IServicer> {
            return this.$http.post("/api/servicer/updateservicer", model);
        };

        enableServicerSL(model: domains.IServicer): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/enableservicersl", model);
        };

        reactivateServicerSL(model: domains.IServicer): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/reactivateservicersl", model);
        };

        disableServicerSL(model: domains.IServicer): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/disableservicersl", model);
        };

        setSsoModeServicerSL(model: domains.IServicer, mode: number): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/setssomodeservicersl/" + mode, model);
        }

        setTwoFactorServicerSL(model: domains.IServicer, enabled: boolean, days?: number): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/settwofactorservicersl/" + enabled + (days ? "?days=" + days : ""), model);
        };

        getServicerTwoFactor(username: string): ng.IHttpPromise<domains.identity.ITwoFactorSetup> {
            return this.$http.get("/api/servicer/getservicertwofactor/" + username);
        };

        setServicerPhone(username: string, phone: string): ng.IHttpPromise<domains.identity.ITwoFactorSetup> {
            return this.$http.post("/api/servicer/setservicerphone/" + username, { phone: phone });
        };

        lockServicerSL(model: domains.IServicer): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/lockservicersl", model);
        };

        unlockServicerSL(model: domains.IServicer): ng.IHttpPromise<{}> {
            return this.$http.post("/api/servicer/unlockservicersl", model);
        };
        // ////////////////////////////////////////////////////////
        // custodians
        getCustodians(): ng.IHttpPromise<domains.ICustodian[]> {
            return this.$http.get("/api/servicer/getcustodians");
        };
        getCustodian(custodianId: number): ng.IHttpPromise<domains.ICustodian> {
            return this.$http.get("/api/servicer/getcustodian/" + custodianId);
        };
        updateCustodian(custodian: domains.ICustodian): ng.IHttpPromise<domains.ICustodian> {
            return this.$http.put("/api/servicer/addorupdatecustodian", custodian);
        };
        createCustodian(custodian: domains.ICustodian): ng.IHttpPromise<domains.ICustodian> {
            return this.$http.post("/api/servicer/addorupdatecustodian", custodian);
        };
        deleteCustodian(custodianId: number): ng.IHttpPromise<{}> {
            return this.$http.delete("/api/servicer/addorupdatecustodian/" + custodianId);
        };
        searchCustodian(searchTerm: string): ng.IHttpPromise<domains.ICustodian[]> {
            return this.$http.get("api/servicer/searchcustodian/" + searchTerm);
        };

        // ////////////////////////////////////////////////
        // custodian - advisory firms
        getCustodianAdvisoryFirm(custodianAdvisoryFirmId: number):
            ng.IHttpPromise<domains.ICustodianAdvisoryFirm> {
            return this.$http.get("/api/servicer/getcustodianadvisoryfirm/" + custodianAdvisoryFirmId);
        };
        createCustodianAdvisoryFirm(custodianAdvisoryFirm: domains.ICustodianAdvisoryFirm):
            ng.IHttpPromise<domains.ICustodianAdvisoryFirm> {
            return this.$http.post("/api/servicer/addorupdatecustodianadvisoryfirm", custodianAdvisoryFirm);
        };
        relinkCustodianAdvisoryFirm(custodianAdvisoryFirm: domains.ICustodianAdvisoryFirm):
            ng.IHttpPromise<domains.ICustodianAdvisoryFirm> {
            return this.$http.put("/api/servicer/addorupdatecustodianadvisoryfirm", custodianAdvisoryFirm);
        };
        deleteCustodianAdvisoryFirm(custodianAdvisoryFirmId: number): ng.IHttpPromise<domains.ICustodianAdvisoryFirm> {
            return this.$http.delete("/api/servicer/deletecustodianadvisoryfirm/" + custodianAdvisoryFirmId);
        };
        
        // ////////////////////////////////////////////////
        // Custodian office ranges / master accounts
        createOfficeRange(officeRange: domains.ICustodianAdvisoryFirmOfficeRange):
            ng.IHttpPromise<domains.ICustodianAdvisoryFirmOfficeRange> {
            return this.$http.post("/api/servicer/addorupdateofficerange", officeRange);
        };
        updateOfficeRange(officeRange: domains.ICustodianAdvisoryFirmOfficeRange):
            ng.IHttpPromise<domains.ICustodianAdvisoryFirmOfficeRange> {
            return this.$http.put("/api/servicer/addorupdateofficerange", officeRange);
        };

        getInvestors(): ng.IHttpPromise<Array<domains.IInvestor>> {
            return this.$http.get("/api/servicer/getinvestors");
        };

        getInvestorsLight(): ng.IHttpPromise<Array<domains.IInvestor>> {
            return this.$http.get("/api/servicer/getinvestorslight");
        };

        // #region LINK between investors
        saveLinkType(linkType: domains.ILinkType):
            ng.IHttpPromise<domains.ILinkType> {
            return this.$http.post("/api/servicer/savelinktype", linkType);
        };

        addLink(link: domains.ILink): ng.IHttpPromise<domains.ILink> {
            return this.$http.put("/api/servicer/addLink", link);
        };

        deleteLink(linkId: number): ng.IHttpPromise<any> {
            return this.$http.delete(`/api/servicer/deleteLink/${linkId}`);
        }
        // #endregion links

        // #region Securities
        getSecurityAllocationPlans(advisoryFirmId: number): ng.IHttpPromise<domains.ISecurityAllocationPlan[]> {
            return this.$http.get(`/api/servicer/getsecurityallocationplans/${advisoryFirmId}`);
        };
        getAFSecurityAllocationPlans(advisoryFirmId: number): ng.IHttpPromise<domains.IAFSecurityAllocationPlan[]> {
            return this.$http.get(`/api/servicer/getafsecurityallocationplans/${advisoryFirmId}`);
        };
        getSecurityAllocationPlan(allocationPlanId: number): ng.IHttpPromise<domains.ISecurityAllocationPlan> {
            return this.$http.get(`/api/servicer/getsecurityallocationplan/${allocationPlanId}`);
        };
        getAFSecurityAllocationPlanAndClassns(allocationPlanId: number): ng.IHttpPromise<any> {
            return this.$http.get(`/api/servicer/getafsecurityallocationplanandclassns/${allocationPlanId}`);
        };
        cloneSecurityAllocationPlan(advisoryFirmId: number, newAllocationPlanName: string, originalPlan: domains.ISecurityAllocationPlan): ng.IHttpPromise<domains.ISecurityAllocationPlan> {
            var newname = encodeURIComponent(this.replaceSlashes(newAllocationPlanName));
            return this.$http.post(`/api/servicer/clonesecurityallocationplan/${advisoryFirmId}/${newname}`, originalPlan);
        };
        createAFSecurityAllocationPlan(allocationPlan: domains.IAFSecurityAllocationPlan): ng.IHttpPromise<domains.IAFSecurityAllocationPlan> {
            return this.$http.post(`/api/servicer/createafsecurityallocationplan/`, allocationPlan);
        };
        cloneAFSecurityAllocationPlan(advisoryFirmId: number, newAllocationPlanName: string, originalPlan: domains.IAFSecurityAllocationPlan): ng.IHttpPromise<domains.IAFSecurityAllocationPlan> {
            var newname = encodeURIComponent(this.replaceSlashes(newAllocationPlanName));
            return this.$http.post(`/api/servicer/cloneafsecurityallocationplan/${advisoryFirmId}/${newname}`, originalPlan);
        };
        updateSecurityAllocationPlan(allocationPlanId: number, useStyleBased: boolean): ng.IHttpPromise<boolean> {
            return this.$http.post(`/api/servicer/updatesecurityallocationplan/${allocationPlanId}`, useStyleBased);
        };
        //updateSecurityAssetClassAllocation(allocation: domains.ISecurityAssetClass): ng.IHttpPromise<domains.ISecurityAllocationPlan> {
        //    return this.$http.post(`/api/servicer/updatesecurityassetclassallocation`, allocation);
        //};
        updateSecurityAssetClassAllocations(allocations: domains.ISecurityAssetClass[]): ng.IHttpPromise<void> {
            return this.$http.put(`/api/servicer/securityassetclassallocation`, allocations);
        };
        updateAFSecurityAssetClassAllocations(allocations: domains.IAFSecurityAssetClass[]): ng.IHttpPromise<void> {
            return this.$http.put(`/api/servicer/afsecurityassetclassallocation`, allocations);
        };
        activateAFSecurityAllocationPlan(allocationPlanId: number): ng.IHttpPromise<boolean> {
            return this.$http.get(`/api/servicer/activateafsecurityallocationplan/${allocationPlanId}`);
        };
        // #endregion Securities

        // #region New Risk Model
        getAfcModels(advisoryFirmId: number, enabledOnly = false): ng.IHttpPromise<domains.IAFAssetClassnModel[]> {
            return this.$http.get(`/api/servicer/afc/model/list/${advisoryFirmId}/${enabledOnly}`);
        }
        getAfcModel(afcModelId: number): ng.IHttpPromise<domains.IAFAssetClassnModel> {
            return this.$http.get(`/api/servicer/afc/model/${afcModelId}`);
        }
        saveAfcModel(model: any): ng.IHttpPromise<domains.IAFAssetClassnModel> {
            return this.$http.post(`/api/servicer/afc/model`, model);
        }
        deleteAfcModel(afcModelId: number): ng.IHttpPromise<any> {
            return this.$http.delete(`/api/servicer/afc/model/${afcModelId}`);
        }
        lockAfcModel(afcModel: domains.IAFAssetClassnModel): ng.IHttpPromise<domains.IAFAssetClassnModel> {
            return this.$http.put(`/api/servicer/afc/lockmodel`, afcModel);
        }
        updateAfcModel(afcModel: domains.IAFAssetClassnModel): ng.IHttpPromise<domains.IAFAssetClassnModel> {
            return this.$http.put(`/api/servicer/afc/model`, afcModel);
        }

        getAfcClassifications(afcModelId: number): ng.IHttpPromise<domains.IAFAssetClassnClassn[]> {
            return this.$http.get(`/api/servicer/afc/classifications/${afcModelId}`);
        }
        saveAfcClassifications(saveObj: domains.IFAssetClassModelAndClassifications): ng.IHttpPromise<domains.IAFAssetClassnClassn[]> {
            return this.$http.post(`/api/servicer/afc/classifications`, saveObj);
        }

        //getAfcClass(afcClassId: number): ng.IHttpPromise<domains.IAFAssetClassnClassn> {
        //    return this.$http.get(`/api/servicer/afc/class/${afcClassId}`);
        //}
        //updateAfcClass(afcClass: domains.IAFAssetClassnClassn): ng.IHttpPromise<domains.IAFAssetClassnClassn> {
        //    return this.$http.put(`/api/servicer/afc/class`, afcClass);
        //}
        //deleteAfcClass(afcClassId: number): ng.IHttpPromise<any> {
        //    return this.$http.delete(`/api/servicer/afc/class/${afcClassId}`);
        //}
        // #endregion New Risk Model

        // #region Report templates
        searchReportTemplates(searchTerm: string): ng.IHttpPromise<domains.IRepFeeGroup[]> {
            return this.$http.get("/api/servicer/searchreporttemplates/" + searchTerm);
        };
        getReportTemplates(): ng.IHttpPromise<Array<domains.IReportTemplate>> {
            return this.$http.get("/api/servicer/getreporttemplates");
        };
        // 

        //#region external systems

        //getExternalSystems(): ng.IHttpPromise<domains.IExternalSystem[]> {
        //    return this.$http.get("/api/servicer/getExternalSystems");
        //}

        //getExternalSystemsByType(type: domains.ExternalSystemType): ng.IHttpPromise<domains.IExternalSystem[]> {
        //    return this.$http.get(`/api/servicer/getExternalSystemsByType/${type}`);
        //}

        getExternalSystemDataMapping(advisorFieldId: number, mappingType: domains.ExternalMappingType): ng.IHttpPromise<domains.IExternalSystemDataMapping[]> {
            return this.$http.get(`/api/servicer/getexternalsystemdatamapping/${advisorFieldId}/${mappingType}`);
        }

        createExternalSystemDataMapping(model: domains.IExternalSystemDataMapping): ng.IHttpPromise<domains.IExternalSystemDataMapping> {
            return this.$http.post(`/api/servicer/createexternalsystemdatamapping`, model);
        }

        updateExternalSystemDataMapping(model: domains.IExternalSystemDataMapping): ng.IHttpPromise<domains.IExternalSystemDataMapping> {
            return this.$http.put(`/api/servicer/updateexternalsystemdatamapping`, model);
        }

        deleteExternalSystemDataMapping(id: number): ng.IHttpPromise<any> {
            return this.$http.delete(`/api/servicer/deleteexternalsystemdatamapping/${id}`);
        }
        createUpdateExternalSystemDataMappings(mappings: domains.IExternalSystemDataMapping[]): ng.IHttpPromise<void> {
            return this.$http.post(`/api/servicer/createupdateexternalsystemdatamappings`, mappings);
        }

        //getExternalSystem(id: number): ng.IHttpPromise<domains.IAdvisorExternalSystem> {
        //    return this.$http.get(`/api/advisor/getExternalSystem/${id}`);
        //};
        loadSalesforceUsers(companyGroupId: number): ng.IHttpPromise<any[]> {
            return this.$http.get(`/api/servicer/loadsalesforceusers/${companyGroupId}`);
        }
        loadOrionRepresentatives(companyGroupId: number): ng.IHttpPromise<any[]> {
            return this.$http.get(`/api/orion/representatives`);
        }
        //#endregion external systems

        //#region DMS
        getAdvisoryFirmDocumentation(advisoryFirmId: number, includeHistory: boolean = false, showDeletedFiles: boolean = false): ng.IHttpPromise<any[]> {
            return this.$http.get(`api/servicer/getadvisoryfirmdocumentation/${advisoryFirmId}/${includeHistory}/${showDeletedFiles}`);
        };
        disableDocument(documentId: number, documentVersion: number): ng.IHttpPromise<any> {
            return this.$http.delete(`api/servicer/disabledocument/${documentId}/${documentVersion}`);
        };
        enableDocument(documentId: number, documentVersion: number): ng.IHttpPromise<any> {
            return this.$http.delete(`api/servicer/enabledocument/${documentId}/${documentVersion}`);
        };
        //#endregion DMS

        //#region AdvisoryFirm-Servicer
        getAdvisoryFirmsByServicer(servicerId: string): ng.IHttpPromise<domains.IAdvisoryFirm[]> {
            return this.$http.get(`/api/servicer/advisoryfirmservicer/byservicer/${servicerId}`);
        }
        getServicersAssignedToFirm(advisoryFirmId: number): ng.IHttpPromise<domains.IServicer[]> {
            return this.$http.get(`/api/servicer/advisoryfirmservicer/byadvisoryfirm/${advisoryFirmId}`);
        }
        assignAdvisoryFirmToServicer(advisoryFirmServicer: domains.IAdvisoryFirmServicer): ng.IHttpPromise<domains.IAdvisoryFirmServicer> {
            return this.$http.post(`/api/servicer/advisoryfirmservicer`, advisoryFirmServicer);
        }
        unassignAdvisoryFirmFromServicer(advisoryFirmId: number, servicerId: string): ng.IHttpPromise<any> {
            return this.$http.delete(`/api/servicer/advisoryfirmservicer/${advisoryFirmId}/${servicerId}`);
        }

        /**
         * Calculate PpLevel and PpClientId based on account data
         */
        calculatePpLevelAndClientId = (level: string, boRtgId: string, boCustodialAccountNumber: string,
            boUMAAccountIdentifierString: string): { pplevel: string, ppclientid: string } => {

            let noData = false;

            const ppData = {
                pplevel: null,
                ppclientid: null
            };

            if (level == "H") {
                // WE DONT SYNC OUR HH WITH PP
                noData = true;
            } else if (level == "R") {
                // AdvisorOp RTG level is PP household level
                if (boRtgId) {
                    ppData.pplevel = "HH";
                    ppData.ppclientid = boRtgId;
                } else {
                    noData = true;
                }
            }
            else if (level == "A") {
                // AdvisorOp account level can be PP account or PP client group level
                // Checking first char of boUMAAccountIdentifierString is a hack to identify Folio accounts
                // We need to provide custodian from the server query and check that here instead.
                if (boUMAAccountIdentifierString && boUMAAccountIdentifierString.charAt(0) != 'R') {
                    ppData.pplevel = "CG";
                    ppData.ppclientid = "U-" + boUMAAccountIdentifierString;
                } else if (boCustodialAccountNumber) {
                    ppData.pplevel = "AC";
                    ppData.ppclientid = boCustodialAccountNumber;
                } else {
                    noData = true;
                }
            }
            else if (level == "S") {
                // AdvisorOp sleeve level is PP account level
                if (boCustodialAccountNumber) {
                    ppData.pplevel = "AC";
                    ppData.ppclientid = boCustodialAccountNumber;
                } else {
                    noData = true;
                }
            }

            if (noData) {
                // toastr.warning("There is no available back office data for this selection.");
                return null;
            }

            return ppData;
        }

        calculateOrionParamsAsync = (level: string, entityId: string): angular.IPromise<domains.IBackOfficeParams> => {
            // it must be AdvisorOp level and AdvisorOp EntityId
            if (!level || !entityId) {
                return null;
            }

            let backOfficeParams: domains.IBackOfficeParams;

            return this.backOfficeLinkApi.calculateOrionParams(level, parseInt(entityId))
                .then((response) => {
                    console.log(`We've got orion params:`, response.data);
                    const data = response.data as domains.IBackOfficeOrionParams;
                    const mappedParams: domains.IBackOfficeParams = {
                        backOfficeLevel: data.backOfficeLevel,
                        backOfficeEntityId: data.backOfficeEntityId?.toString()
                    };
                    return mappedParams;
                })
                .catch((err) => {
                    console.error(`Error calculating Orion back office params for level: ${level}, entityId: ${entityId}`, err);
                    throw err;
                });
        }

        /**
         * Open PP report in a new browser window
         */
        openPPReport = (report: string, ppParams: { pplevel, ppclientid }): void => {

            //if (ppParams == null || !report) {
            //    //console.log(`PP report cannot be called. There is no report or param data. report: ${report}, params:`, backOfficeParams);
            //    return;
            //}

            //let url = `/samlidp/openppreport/${ppParams.pplevel}/${ppParams.ppclientid}/${report}`;
            //if (!this.ppWnds[ppParams.ppclientid] || (<Window>this.ppWnds[ppParams.ppclientid]).closed) {
            //    //console.log("Opening report in new window: " + report);
            //    this.ppWnds[ppParams.ppclientid] = window.open(url, "_blank");
            //    if (!this.ppWnds[ppParams.ppclientid]) {
            //        toastr.warning("Your browser is blocking popups from this site. Please enable popups for AdvisorOp.");
            //    }
            //} else {
            //    //console.log("Opening report in existing window: " + report);
            //    this.ppWnds[ppParams.ppclientid].location.href = url;
            //    this.ppWnds[ppParams.ppclientid].focus();
            //}
            
            return this.openOrionReport(report, { backOfficeLevel: ppParams.pplevel, backOfficeEntityId: ppParams.ppclientid });
        }

        public openOrionReport = (report: string, params: domains.IBackOfficeParams): void => {
            console.log(`Report: ${report} Level ${params.backOfficeLevel}, ClientId ${params.backOfficeEntityId}`);

            let url = `https://api.cloud.orionadvisor.com/orionconnectapp/#/orion/dashboard`;
            if (report === 'OrionDashboard') {
                url = `https://api.cloud.orionadvisor.com/orionconnectapp/#/orion/dashboard?entity=${params.backOfficeLevel}&entityId=${params.backOfficeEntityId}`;
            }
            console.log('Url: ', url);


            if (!this.ppWnds[0] || (<Window>this.ppWnds[0]).closed) {
                //console.log("Opening report in new window: " + report);
                this.ppWnds[0] = window.open(url, "_blank");
                if (!this.ppWnds[0]) {
                    toastr.warning("Your browser is blocking popups from this site. Please enable popups for AdvisorOp.");
                }
            } else {
                //console.log("Opening report in existing window: " + report);
                this.ppWnds[0].location.href = url;
                this.ppWnds[0].focus();
            }
        }

        //#endregion AdvisoryFirm-Servicer

        setAdvisorRepId(model: domains.IAdvisorCustodian): ng.IHttpPromise<domains.IAdvisorCustodian> {
            //we will clean model first 
            const m: domains.IAdvisorCustodian = {};
            angular.copy(model, m);
            m.custodian = null;
            m.advisoryFirm = null;
            //console.log(`New object: `, m);
            return this.$http.post(`/api/servicer/setadvisorrepid`, m);
        }

        removeAdvisorRepId(advisorCustodianId: number): ng.IHttpPromise<any> {
            return this.$http.delete(`/api/servicer/removeadvisorrepid/${advisorCustodianId}`);
        }

        getManualAccountsForExport(advisoryFirmId): ng.IHttpPromise<domains.IManualAccountExport[]> {
            return this.$http.get(`api/servicer/manualaccountsforexport/${advisoryFirmId}`);
        }
        updateManualAccountsExportedDate(accountIds: number[]): ng.IHttpPromise<domains.IManualAccountExport[]> {
            return this.$http.post(`api/servicer/manualaccountsforexport`, accountIds);
        }

        adobesignIntegrationCheck(): ng.IHttpPromise<string> {
            return this.$http.get(`api/integration/adobesignintegrationcheck`);
        };
        adobesignIntegrationRequest(): ng.IHttpPromise<string> {
            return this.$http.get(`api/integration/adobesignintegrationrequest`);
        };
        adobesignIntegrationResponse(code: string, apiAccessPoint: string, webAccessPoint: string, state: string): ng.IHttpPromise<{}> {
            return this.$http
                .post("api/integration/adobesignintegrationresponse",
                    {
                        item1: code,
                        item2: apiAccessPoint,
                        item3: webAccessPoint,
                        item4: state
                    });
        };
        docusignIntegrationCheck(): ng.IHttpPromise<string> {
            return this.$http.get(`api/integration/docusignintegrationcheck`);
        };
        docusignIntegrationRequest(): ng.IHttpPromise<string> {
            return this.$http.get(`api/integration/docusignintegrationrequest`);
        };
        docusignIntegrationResponse(code: string, state: string): ng.IHttpPromise<{}> {
            return this.$http
                .post("api/integration/docusignintegrationresponse",
                    {
                        item1: code,
                        item2: state
                    });
        };
        orionIntegrationCheck(): ng.IHttpPromise<string> {
            return this.$http.get(`api/integration/orionintegrationcheck`);
        };
        orionIntegrationRequest(): ng.IHttpPromise<string> {
            return this.$http.get(`api/integration/orionintegrationrequest`);
        };
        orionIntegrationResponse(code: string, state: string): ng.IHttpPromise<{}> {
            return this.$http
                .post("api/integration/orionintegrationresponse",
                    {
                        item1: code,
                        item2: state
                    });
        };

        msgraphIntegrationCheck(): ng.IHttpPromise<string> {
            return this.$http.get(`api/integration/msgraphintegrationcheck`);
        };
        msgraphIntegrationRequest(): ng.IHttpPromise<string> {
            return this.$http.get(`api/integration/msgraphintegrationrequest`);
        };
        msgraphIntegrationResponse(code: string, state: string): ng.IHttpPromise<{}> {
            return this.$http
                .post("api/integration/msgraphintegrationresponse",
                    {
                        item1: code,
                        item2: state
                    });
        };

        searchInvestorsHouseholds(searchTerm: string): ng.IHttpPromise<Array<{}>> {
            var sterm = encodeURIComponent(this.replaceSlashes(searchTerm));
            return this.$http.get(`/api/servicer/searchhouseholdsinvestors/` + sterm);
        }

        searchAccounts(searchTerm: string, accountType?: number): ng.IHttpPromise<Array<{}>> {
            var sterm = encodeURIComponent(this.replaceSlashes(searchTerm));
            if (accountType == null) {
                return this.$http.get(`/api/servicer/searchaccounts/` + sterm);
            } else {
                return this.$http.get(`/api/servicer/searchaccounts/` + sterm + "/" + accountType);
            }
        }
    }
    angular.module(Constants.ADVOP_SERVICES).service("servicerService", ServicerService);
}